module.exports = __webpack_public_path__ + "img/product_02.25569722.jpg";